<template>
	<div>
		<!-- <NotificationIframe></NotificationIframe> -->
		<main role="main" style = "padding-top:0px">
			<div style = "background-color:#3da3a7;width: 100%;margin: 0px;" class = "form-group row">
				<a class ="col-md-11 text-left" href="#/campaignList" style = "padding-left:0px"><img alt="Global Overview" src="../../assets/images/logo.png" style = "padding:5px;"/></a>

				<!-- <img alt="Global Overview" src="../../assets/images/logo.png" style = "padding:5px"/> -->
				<div class="col-md-1 align-self-center text-right" style = "font-size: 16px;color:white;padding-right:5px;text-decoration: none;font-weight: 300;cursor: pointer;" @click = "goBack()">Close</i></div>
			</div>
			<div class="container-fluid">
				<div style = "padding-top:10px"></div>
				<MappingHeader/>
				<MappingFilter :vendorMasterList = "vendorMasterList"/>
			</div>
		</main>
	</div>
</template>

<script>

import MappingHeader from '@/components/mapping/MappingHeader'
import MappingFilter from '@/components/mapping/MappingFilter'


export default {
	name: "Mapping",
	components:{
		MappingHeader,
		MappingFilter
	},
	data(){
		return{
			showLoader:false,
			vendorMasterList:[]
		}
	},
	computed:{
	},
	mounted(){
		this.$store.dispatch("getVendorForNameList");
		this.$store.dispatch("getAccountVendors").then((res) => {
			this.vendorMasterList = res
		})
	},
	methods:{
		goBack(){
			this.$router.push({path:'/campaignList'})
		}
	}
}
</script>
